<template>
    <!-- <div v-if="this.src2" style="display: grid;">
        <v-img class="img1" contain :src="urlImg2"/>
        <v-img contain :src="urlImg" max-width="160" max-height="160" :key="componentKey"  @error="onErrorImg()"/>
    </div>
    <div v-else style="display: grid;">
        <v-img contain :src="urlImg" max-width="160" max-height="160" :key="componentKey"  @error="onErrorImg()"/>
    </div> -->

    <div class="img-wrapper">
        <v-img v-if="src2" class="img-etiqueta" contain :src="urlImg2" @error="onErrorImg2" />

        <v-img class="img-principal" contain :src="urlImg" :key="componentKey" @error="onErrorImg" />
    </div>


</template>

<script>
export default {
    name: 'Imagen',
    props:{src: {type: String}, src2: {type: String}},
    data(){
        return{
            componentKey:0,
            urlImg: null,
            urlImg2: null,
        }
    },
    methods:{   
        onErrorImg(){
            this.urlImg = require('../assets/default_image.png')
            this.componentKey++//PARA ACTUALIZAR 
        },
        onErrorImg2(){
            this.urlImg2 = require('../assets/default_image.png')
            this.componentKey++//PARA ACTUALIZAR 
        }
    
    },
    mounted(){
        this.urlImg = this.src
        this.urlImg2 = this.src2
    },
    computed:{  
    },
    watch:{
    }

}
</script>

<style scoped>
.img1 {
    position: absolute;
    z-index: 1;
    max-width: 80px;
    max-height: 17px;
}

.img-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: visible;
    /* importante para que se vea la etiqueta */
}

.img-principal {
    width: 100%;
    height: 100%;
}

.img-etiqueta {
    position: absolute;

    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    top: -10px;

    max-width: 60px;
    max-height: 14px;
}
</style>